import { React, useState } from 'react';

import {
    Box,
    Button,
    FormControl,
    Grid,
    InputAdornment,
    Paper,
    Stack,
    TextField, Typography
} from '@mui/material';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';

const LancarPagamentosBradesco = () => {
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [arquivo, setArquivo] = useState(null);
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitPagamentosBradesco(e) {
        e.preventDefault();
        setIsSubmit(true);

        const formData = new FormData();
        formData.append('arquivoCSV', arquivo);

        const response = await fetchFlask('lancarPagamentosBradesco', formData);
        handleAlerta(response);
        setIsSubmit(false);
         if (response.status === 'success') {
            setArquivo(null);
        }
    };

    function handleAlerta(response) {
        setMessage(response.message);
        setStatus(response.status);
        setOpenAlerta(true);
    }

    return (
        <Box className='mainBox'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>CSV - EXTRATO DE PAGAMENTOS BRADESCO</PageHeader>

            <form action='' method='POST' id='pagamentosBradesco' onSubmit={submitPagamentosBradesco}>
                <Grid container spacing={1} justifyContent='center' alignItems='center'>
                    <Grid item xs={5}>
                        <Paper elevation={3} sx={{ padding: 2, marginTop: '20px' }}>
                            <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                                <Typography>ARQUIVO CSV</Typography>
                                <TextField
                                    value={arquivo?.name || ''}
                                    placeholder='Selecione o arquivo CSV'
                                    size='small'
                                    fullWidth
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: (
                                            <InputAdornment position='end'>
                                                <Button component='label' variant='contained' sx={{ whiteSpace: 'nowrap' }}>
                                                    Escolher arquivo
                                                    <input
                                                        hidden
                                                        type='file'
                                                        accept='.csv,text/csv'
                                                        onChange={(e) => setArquivo(e.target.files[0] || null)}
                                                    />
                                                </Button>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </FormControl>

                            <Grid container justifyContent="center" sx={{ mt: 3 }}>
                                <Grid item xs={6}>
                                    <FormControl sx={{ display: 'flex' }}>
                                        <Stack spacing={1}>
                                            <SubmitButton isSubmit={isSubmit} >Lançar pagamentos</SubmitButton>
                                        </Stack>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
};

export default LancarPagamentosBradesco;
